import React from "react";
import "../cdn.scss";
export const Section = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    tag = "h2",
    link = "",
    href = "",
    target = "",
    onClick = () => null,
    title = "",
    mt = 12,
    children,
    className = ""
  } = _ref;
  const Tag = tag;
  return /*#__PURE__*/React.createElement("section", {
    className: ["container", "mt-".concat(mt), ...className.split(" ")].filter(v => !!v).join(" "),
    ref: ref
  }, link ? /*#__PURE__*/React.createElement("div", {
    className: "flex"
  }, title && /*#__PURE__*/React.createElement(Tag, {
    className: "fs-h2"
  }, title), href ? /*#__PURE__*/React.createElement("a", {
    href: href,
    target: target,
    onClick: onClick,
    className: "more-link"
  }, /*#__PURE__*/React.createElement("span", null, link), /*#__PURE__*/React.createElement("i", {
    className: "fa-regular fa-chevron-right"
  })) : /*#__PURE__*/React.createElement("span", {
    onClick: onClick,
    className: "more-link"
  }, /*#__PURE__*/React.createElement("span", null, link), /*#__PURE__*/React.createElement("i", {
    className: "fa-regular fa-chevron-right"
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, title && /*#__PURE__*/React.createElement(Tag, {
    className: "fs-h2"
  }, title)), children);
});